export enum WebsiteCreationStatusEnum {
  Sharing = 'sharing',
  Completed = 'completed',
}
